<template>
  <div>
    <card class="card">
      <div v-if="idTabA != null">
        <div v-if="modificaTabella == false">
          <button class="btn float-left" type="button" v-on:click="modificaVediTabella()" style="margin-top:20px;background:#00467f">Modifica Tabella</button>
        </div>
        <div v-else>
          <button class="btn float-left" type="button" v-on:click="modificaVediTabella()" style="margin-top:20px;background:#00467f">Vedi Tabella</button>
        </div>
      </div>
      <label style="color:black; font-size:18px;font-weight:bold">A. Aspetti connessi al cliente</label>
      <table class="table tablesorter" id="tabella" style="text-align: center">
        <thead>
          <tr>
            <th></th>
            <th>Fattore di rischio riscontrato</th>
            <th>Valore</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Natura Giuridica</td>
            <td style="text-align:left">
              <div class="row">
                <div class="col-11">Non congruità della natura giuridica prescelta in relazione all’attività svolta e alle sue dimensioni<hr></div>
                <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                  <input type="checkbox" v-model="a1_1" v-on:change="updateValue('a1_1')"/>
                </div>
                <div class="col-1" v-else>
                  <!-- <input type="checkbox" v-model="a1_1" v-on:change="updateValue('a1_1')"/> -->
                    <span v-if="a1_1 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                </div>
              </div>
              <div class="row">
                <div class="col-11">Articolazione giuridica, complessità e opacità della struttura volte ad ostacolare l’identificazione del titolare effettivo o l’attività concretamente svolta<hr></div>
                <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                  <div class="col-1"><input type="checkbox" v-model="a1_2" v-on:change="updateValue('a1_2')"/></div>
                </div>
                <div class="col-1" v-else>
                  <!-- <input type="checkbox" v-model="a1_2" v-on:change="updateValue('a1_1')"/> -->
                    <span v-if="a1_2 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                </div>
              </div>
              <div class="row">
                <div class="col-11">Partecipazione di persone politicamente esposte (cliente, esecutore, titolare effettivo)<hr></div>
                <div class="col-1"  v-if="idTabA == null || modificaTabella == true">
                  <input type="checkbox" v-model="a1_3" v-on:change="updateValue('a1_3')"/>
                </div>
                <div class="col-1" v-else>
                  <!-- <input type="checkbox" v-model="a1_3" v-on:change="updateValue('a1_1')"/> -->
                    <span v-if="a1_3 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                </div>
              </div>
              <div class="row">
                <div class="col-11">Incarichi in società, associazioni, fondazioni, organizzazioni non lucrative, organizzazioni non governative soprattutto se aventi sede in paesi ad alto rischio o non collaborativi<hr></div>
                <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                  <input type="checkbox" v-model="a1_4" v-on:change="updateValue('a1_4')"/>
                </div>
                <div class="col-1" v-else>
                  <!-- <input type="checkbox" v-model="a1_4" v-on:change="updateValue('a1_1')"/> -->
                    <span v-if="a1_4 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                </div>
              </div>
              <div class="row">
                <div class="col-11">Processi penali o indagini in corso per circostanze attinenti al terrorismo, al riciclaggio o all’autoriciclaggio - Misure di prevenzione o provvedimenti di sequestro - Familiarità/stretti legami con soggetti sottoposti a indagini o a procedimenti penali o provvedimenti di sequestro o censiti nelle liste delle persone o degli enti attivi nel finanziamento del terrorismo[1]<hr></div>
                <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                  <input type="checkbox" v-model="a1_5" v-on:change="updateValue('a1_5')"/>
                </div>
                <div class="col-1" v-else>
                  <!-- <input type="checkbox" v-model="a1_5" v-on:change="updateValue('a1_1')"/> -->
                    <span v-if="a1_5 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                </div>
              </div>
              <div class="row">
                <div class="col-11">Altro</div>
                <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                  <input type="checkbox" v-model="a1_6" v-on:change="updateValue('a1_6')"/>
                </div>
                <div class="col-1" v-else>
                  <span v-if="a1_6 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                  <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                </div>
              </div>
            </td>
            <td>{{valore_natura_giuridicaA1}}</td>
          </tr>
          <tr>
            <td>Prevalente attività svolta</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Attività esposte al rischio di infiltrazioni criminali e terroristiche secondo le periodiche pubblicazioni delle Autorità in materia, sia a livello sovranazionale (Relazione UE sulla valutazione del rischio sovranazionale), sia a livello nazionale (triennale: “Analisi nazionale dei rischi di riciclaggio e finanziamento del terrorismo” MEF/CSF e annuale: “Rapporto annuale dell’Unità di Informazione Finanziaria” UIF/Bankitalia nonché la Relazione annuale al Parlamento del MEF)<hr></div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a2_1" v-on:change="updateValue('a2_1')"/>
                  </div>
                  <div class="col-1" v-else>
                    <span v-if="a2_1 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                </div>
                </div>
                <div class="row">
                  <div class="col-11">Struttura organizzativa e dimensionale non coerente con l’attività svolta<hr></div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a2_2" v-on:change="updateValue('a2_2')"/>
                  </div>
                  <div class="col-1" v-else>
                    <span v-if="a2_2 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Non conformità dell’attività svolta rispetto a quella indicata nell’atto costitutivo<hr></div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a2_3" v-on:change="updateValue('a2_3')"/>
                  </div>
                  <div class="col-1" v-else>
                    <span v-if="a2_3 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a2_4" v-on:change="updateValue('a2_4')"/>
                  </div>
                   <div class="col-1" v-else>
                    <span v-if="a2_4 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
            </td>
            <td>{{valore_attivita_prevalente_svoltaA2}}</td>
          </tr>
          <tr>
            <td>Comportamento tenuto al momento del conferimento dell’incarico</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Cliente non presente fisicamente<hr></div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a3_1" v-on:change="updateValue('a3_1')"/>
                  </div>
                   <div class="col-1" v-else>
                    <span v-if="a3_1 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Presenza di soggetti terzi con ruolo non definito<hr></div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a3_2" v-on:change="updateValue('a3_2')"/>
                    </div>
                  <div class="col-1" v-else>
                    <span v-if="a3_2 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Comportamento non trasparente e collaborativo<hr></div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a3_3" v-on:change="updateValue('a3_3')"/>
                  </div>
                  <div class="col-1" v-else>
                    <span v-if="a3_3 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Difficoltà nell’individuazione del titolare effettivo<hr></div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a3_4" v-on:change="updateValue('a3_4')"/>
                  </div>
                  <div class="col-1" v-else>
                    <span v-if="a3_4 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a3_5" v-on:change="updateValue('a3_5')"/>
                  </div>
                  <div class="col-1" v-else>
                    <span v-if="a3_5 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
            </td>
            <td>{{valore_comportamento_tenutoA3}}</td>
          </tr>
          <tr>
            <td>Area geografica di residenza del cliente</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Residenza/localizzazione in : comune italiano a rischio a causa dell’utilizzo eccessivo di contante – Residenza in Paesi terzi ad alto rischio individuati dalle Autorità – Paesi terzi non dotati di efficaci sistemi di prevenzione del riciclaggio e del finanziamento del terrorismo coerenti con le raccomandazioni del GAFI – Paesi terzi caratterizzati da un elevato livello di corruzione o di permeabilità ad altre attività criminose – Aree di conflitto in cui sono presenti organizzazioni terroristiche o in zone limitrofe o di transito – Paese soggetto a sanzioni o embarghi o misure analoghe stabilite dall’O.N.U. o altri organismi internazionali - (vedasi le pubblicazioni periodiche delle Autorità in materia, sia a livello sovranazionale, sia a livello nazionale)<hr></div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a4_1" v-on:change="updateValue('a4_1')"/>
                  </div>
                  <div class="col-1" v-else>
                    <span v-if="a4_1 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Lontananza della residenza del cliente rispetto alla sede del professionista<hr></div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a4_2" v-on:change="updateValue('a4_2')"/>
                  </div>
                  <div class="col-1" v-else>
                    <span v-if="a4_2 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1" v-if="idTabA == null || modificaTabella == true">
                    <input type="checkbox" v-model="a4_3" v-on:change="updateValue('a4_3')"/>
                  </div>
                  <div class="col-1" v-else>
                    <span v-if="a4_3 == true"><i class="fa fa-check" style="font-size:20px;color:green"></i></span>
                    <span v-else><i class="fa fa-times" style="font-size:20px;color:red"></i></span>
                  </div>
                </div>
            </td>
            <td>{{valore_areageografica_residenzaA4}}</td>
          </tr>
        </tbody>
      </table>
    </card>
    
    <card>
      <div class="row" style="color:black;margin-top:20px">
        <div class="col-4">
          <button class="btn" v-on:click="computeTotal()" style="margin-bottom:20px;background:green">Calcola totale</button>
        </div>
        <div class="col-8" style="text-align:left">
          <div v-show="showTotal">
            <!-- <div v-if="showTableB">
              <p style="color:black">Totale A ({{totaleA}}) + Totale B ({{totaleB}})  =  {{totale}}  :  10  =  {{totale/10}}</p>
            </div>
            <div v-else> -->
            <p style="color:black">Totale A ({{totaleA}}) :  4  =  {{totaleA/4}}</p>
            <!-- </div> -->
            <p style="color:black">Considerato il punteggio calcolato il livello di rischio specifico è classificaile come <span v-bind:style="{background: color}"> {{significativo}}</span> significativo</p>
          </div>
        </div>
      </div>
      <form>
        <div>
          <!-- <div class="form-group col-md-4">
              <label for="dataVerifica">Data Verifica</label>
              <input type="date" class="form-control" v-model="dataVerifica">
          </div>
          <div class="form-group col-md-4">
            <label for="utente">Utente</label>
              <input type="text" class="form-control" v-model="utente">
          </div> -->
          <!-- <div class="form-group col-md-4"> -->
            <button class="btn float-right" type="button" v-on:click="salvaValori()" style="margin-top:20px;background:#00467f">Salva</button>
            <router-link :to="'anagrafica-soggetti?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 20px;margin-right:20px;background:#00467f">Avanti</button></router-link>
            <router-link :to="'/clienti'" class="btn float-right" style="margin-top: 20px;margin-right:10px;background:#00467f">Indietro</router-link>
          <!-- </div> -->
        </div>
      </form>
    </card>
    <!-- <div class="row">
      <div class="col" style="margin-top:5px;margin-bottom:20px">
        <p style="font-size:13px;text-align:center;margin-top:10px;color:black">Data Verifica <input type="date" v-model="dataVerifica" style="margin-right:20px">
        Utente <input type="text" style="margin-left:10px"></p>
      </div>
      <div class="col"><button class="btn float-center" type="button" v-on:click="salvaValori()" style="margin-top: 10px;background:#00467f">Salva</button></div>
    </div> -->
    <!-- -->
    <card class="card" style="margin-top:10px">
      <div class="row">
        <div class="col-5">
          <div style="border: 1px solid">
            <p style="font-size:14px;margin-right:20px;margin-left:20px;margin-top:10px;color:black">
              Punteggi da indicare per la determinazione del rischio<br>
              1 = minimo <br>
              4 = massimo
            </p>
          </div> 
        </div>
        <div class="col-7">
          <div style="border: 1px solid">
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;margin-bottom:5px;margin-top:10px">
              <strong>Grado di rischio</strong>
            </div>
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;background:#9ACD32">
              NON SIGNIFICATIVO
            </div>
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;background:#FFFF00">
              POCO SIGNIFICATIVO
            </div>
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;background:#FFA500">
              ABBASTANZA
            </div>
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;margin-bottom:10px;background:#FF0000">
              MOLTO SIGNIFICATIVO
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Cards/Card.vue';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';
import Services from '@/services/Services';

export default {
  components: {
    Card
  },

  data() {
    return {
      a1_1: false, a1_2: false, a1_3: false, a1_4: false, a1_5: false, a1_6: false,
      valore_natura_giuridicaA1: 1,
      
      a2_1: false, a2_2: false, a2_3: false, a2_4: false,
      valore_attivita_prevalente_svoltaA2: 1,
      
      a3_1: false, a3_2: false, a3_3: false, a3_4: false, a3_5: false,
      valore_comportamento_tenutoA3: 1,
     
      a4_1: false, a4_2: false, a4_3: false,
      valore_areageografica_residenzaA4: 1,
     
      totaleA : 0,
      totale: 0,
      showTotal: false,
      significativo: 'NON',
      color: '',
      dataVerifica: null,

      modificaTabella: true,
      valoriTabellaA: null,
      idTabA: null,
      idCliente: null,
    }
  },

  methods: {
    updateValue: function(value) {
      value = value.substring(0,2);
      // console.log("value: " + value);
      let array = [];
      let counter = 0;
      switch (value) {
        case "a1":
          counter = 0;
          array = [ this.a1_1, this.a1_2, this.a1_3, this.a1_4, this.a1_5, this.a1_6];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_natura_giuridicaA1 = 1;
          } else if (counter == 1) {
            this.valore_natura_giuridicaA1 = 2;
          } else if (counter == 2 ) {
            this.valore_natura_giuridicaA1 = 3;
          }  else {
            this.valore_natura_giuridicaA1 = 4;
          }
          break;
        case "a2":
          counter = 0;
          array = [ this.a2_1, this.a2_2, this.a2_3, this.a2_4];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_attivita_prevalente_svoltaA2 = 1;
          } else if (counter == 1) {
            this.valore_attivita_prevalente_svoltaA2 = 2;
          } else if (counter == 2) {
            this.valore_attivita_prevalente_svoltaA2 = 3;
          }  else {
            this.valore_attivita_prevalente_svoltaA2 = 4;
          }
          break;
        case "a3":
          counter = 0;
          array = [ this.a3_1, this.a3_2, this.a3_3, this.a3_4, this.a3_5];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_comportamento_tenutoA3 = 1;
          } else if (counter == 1) {
            this.valore_comportamento_tenutoA3 = 2;
          } else if (counter == 2) {
            this.valore_comportamento_tenutoA3 = 3;
          }  else {
            this.valore_comportamento_tenutoA3 = 4;
          }
          break;
        case "a4":
          array = [ this.a4_1, this.a4_2, this.a4_3];
          counter = 0;
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_areageografica_residenzaA4 = 1;
          } else if (counter == 1) {
            this.valore_areageografica_residenzaA4 = 2;
          } else if (counter == 2) {
            this.valore_areageografica_residenzaA4 = 3;
          }  else {
            this.valore_areageografica_residenzaA4 = 4;
          }
          break;
      }
    },

    caricaTabella: async function() {
      let errore = 0;
      console.log(`caricaTabella()`);
      await AntiriciclaggioServices.getCliente(this.idCliente)
      .then(response => { this.valoriTabellaA = response.data})
      .catch( function (error) {
          if(error.response.status == 401){
              errore = error.response.status;
          }
      });
      if (errore == 401) {
          let value = await Services.refreshTokenFunction();
          if (value) { await this.caricaCliente(id); }
      }
      console.log(`valoriTabellaA`);
      console.log(this.valoriTabellaA);
      this.valoriTabellaA = this.valoriTabellaA[0].ANTIRIC_TAB_A
      /*
        ANTIRIC_TAB_A: {ID: 3, A1: 1, A2: 1, A3: 1, A4: 1,…}
        A1: 1
        A2: 1
        A3: 1
        A4: 1
        CREATA_DA: null
        DATI: [{A1_1: false, A1_2: false, A1_3: false, A1_4: false, A1_5: false, A1_6: false},…]
        0: {A1_1: false, A1_2: false, A1_3: false, A1_4: false, A1_5: false, A1_6: false}
        1: {A2_1: false, A2_2: false, A2_3: false, A2_4: false}
        2: {A3_1: false, A3_2: false, A3_3: false, A3_4: false, A3_5: false}
        3: {A4_1: false, A4_2: false, A4_3: false}
      */
     console.log(`valoriTabellaA`);
     console.log(this.valoriTabellaA);
      this.a1_1 = this.valoriTabellaA.DATI[0].A1_1;
      this.a1_2 = this.valoriTabellaA.DATI[0].A1_2;
      this.a1_3 = this.valoriTabellaA.DATI[0].A1_3;
      this.a1_4 = this.valoriTabellaA.DATI[0].A1_4;
      this.a1_5 = this.valoriTabellaA.DATI[0].A1_5;
      this.a1_6 = this.valoriTabellaA.DATI[0].A1_6;
      this.valore_natura_giuridicaA1 = this.valoriTabellaA.A1;
      console.log(`a1_1 = ${this.a1_1}, a1_2 = ${this.a1_2}, valore_natura_giuridicaA1 = ${this.valore_natura_giuridicaA1}`);

      this.a2_1 = this.valoriTabellaA.DATI[1].A2_1;
      this.a2_2 = this.valoriTabellaA.DATI[1].A2_2;
      this.a2_3 = this.valoriTabellaA.DATI[1].A2_3;
      this.a2_4 = this.valoriTabellaA.DATI[1].A2_4;
      this.valore_attivita_prevalente_svoltaA2 = this.valoriTabellaA.A2;

      this.a3_1 = this.valoriTabellaA.DATI[2].A3_1;
      this.a3_2 = this.valoriTabellaA.DATI[2].A3_2;
      this.a3_3 = this.valoriTabellaA.DATI[2].A3_3;
      this.a3_4 = this.valoriTabellaA.DATI[2].A3_4;
      this.a3_5 = this.valoriTabellaA.DATI[2].A3_5;
      this.valore_comportamento_tenutoA3 = this.valoriTabellaA.A3;

      this.a4_1 = this.valoriTabellaA.DATI[3].A4_1;
      this.a4_2 = this.valoriTabellaA.DATI[3].A4_2;
      this.a4_3 = this.valoriTabellaA.DATI[3].A4_3;
      this.valore_areageografica_residenzaA4 = this.valoriTabellaA.A4;
      this.modificaTabella = false;
    },

    computeTotal: function() {
      let tot = 0;
      this.showTotal = true;
      this.totaleA = this.valore_natura_giuridicaA1 + this.valore_attivita_prevalente_svoltaA2 + this.valore_comportamento_tenutoA3 + this.valore_areageografica_residenzaA4;
      this.totale = this.totaleA;
      tot = this.totale/4;
      
      if (tot  >= 1 && tot <= 1.5) {
        console.log("here");
        this.significativo = 'NON';
        this.color = '#9ACD32';
      } else if (tot  >= 1.6 && tot <= 2.5) {
        this.significativo = 'POCO';
        this.color = '#FFFF00';
      } else if (tot >= 2.6 && tot <= 3.5) {
        this.significativo = 'ABBASTANZA';
        this.color = '#FFA500';
      } else {
        console.log("tot: " + tot);
        this.significativo = 'MOLTO';
        this.color = '#FF0000';
      }
    },

    caricaValori: async function() {
      if (this.dataVerifica == null) {
        this.dataVerifica = new Date();
      }
    },

    modificaVediTabella: function() {
      this.modificaTabella = !this.modificaTabella;
    },

    salvaValori: async function() {
      let errore = 0;
      let datiA = [
        { A1_1: this.a1_1, A1_2: this.a1_2, A1_3: this.a1_3, A1_4: this.a1_4, A1_5: this.a1_5, A1_6: this.a1_6 },
        { A2_1: this.a2_1, A2_2: this.a2_2, A2_3: this.a2_3, A2_4: this.a2_4 },
        { A3_1: this.a3_1, A3_2: this.a3_2, A3_3: this.a3_3, A3_4: this.a3_4, A3_5: this.a3_5 },
        { A4_1: this.a4_1, A4_2: this.a4_2, A4_3: this.a4_3 }
      ];
      let TAB_A = {
        A1: this.valore_natura_giuridicaA1, A2: this.valore_attivita_prevalente_svoltaA2, A3: this.valore_comportamento_tenutoA3, A4: this.valore_areageografica_residenzaA4, DATI: datiA
      };
      console.log("TAB_A");
      console.log(TAB_A);
      let salvaValori = [];
      await AntiriciclaggioServices.createTabA(this.idCliente, this.idPrestazione, {TAB_A: TAB_A})
      .then(response => { salvaValori= response.data})
      .catch( function (error) {
          if(error.response.status == 401){
          errore = error.response.status;
          }
      });
      if (errore == 401) {
          let value = await Services.refreshTokenFunction();
          if (value) { await this.salvaValori(); }
      }
      let path = 'anagrafica-soggetti?idCliente=' + this.idCliente;
      this.$router.push({
          path: path
      })
    },

    // dateToday: function() {
    //   let data = new Date();
    //   let gg, mm, aaaa; 
    //   gg = data.getDate() + "/"; 
    //   mm = data.getMonth() + 1 + "/"; 
    //   aaaa = data.getFullYear(); 
    //   return data;
    // },
    
    main: async function() {
        this.idCliente = this.$route.query.idCliente;
        if (this.$route.query.idTabA != undefined && this.$route.query.idTabA != null) {
          this.idTabA = this.$route.query.idTabA;
          console.log(`idTabA = ${this.idTabA}`);
          await this.caricaTabella();
        }
        // this.dateToday();
    }
  },
  mounted() {
        this.main();
    } 
};
</script>
<style>

  div{
    font-size:16px
  }

  /* .button {
    background-color: #4CAF50;
    border: none;
    color: white;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
  } */

  td{
    font-size:14px,
  }
  th {
    font-size:16px,
  }

</style>
